export default function convertBirthdayDate(time: string) {
  const config = useRuntimeConfig()
  const date = new Date(time)
  return new Intl.DateTimeFormat(config.public.site.localeCode, {
    // 3. april 2021
    dateStyle: 'long',
  }).format(date)
}
